import React from 'react';

export default function Grade10to9() {
  return (
    <div className="sectionPage grading-page">
      <h1>Promotion Requirements — 10th Gup → 9th Gup</h1>
      <h2>White belt → White belt with Yellow stripe</h2>

      <section>
        <h3>Eligibility & Uniform</h3>
        <p>
          To qualify for this grading, candidates must have attended class for a period of not less than <strong>21 hour-sessions</strong> before they take their next grading.
        </p>
        <p>
          Students must be properly turned out in a clean, tidy uniform approved by the Union and have all membership requirements up to date.
        </p>
      </section>

      <section>
        <h3>Fitness Test (90 second limit per exercise)</h3>
        <p>All the exercises below need to be completed; each exercise has a minimal requirement with a time limit of <strong>90 seconds</strong>:</p>
        <ul>
          <li>Push ups — 20</li>
          <li>Squats — 20 (below 90°)</li>
          <li>Star Jumps — 20</li>
          <li>Wall Sits (90°) — 15–30 seconds</li>
          <li>Sit Ups — 20</li>
          <li>Burpees — 20</li>
        </ul>
      </section>

      <section>
        <h3>Demonstration of Movement</h3>
        <p>Perform each of the following in <em>front stance</em> unless stated otherwise:</p>
        <ul>
          <li>Low block in front stance</li>
          <li>High block in front stance</li>
          <li>Middle punch in front stance</li>
          <li>High punch in front stance</li>
        </ul>
      </section>

      <section>
        <h3>Demonstration of Technique</h3>
        <ul>
          <li>Front leg raises</li>
          <li>Front snap kick</li>
          <li>Jumping front snap kick (age and ability dependent)</li>
        </ul>
      </section>

      <section>
        <h3>Hyungs (Forms)</h3>
        <p>The candidate must demonstrate the following hyungs:</p>
        <ul>
          <li>Dan Bon Cho Dan / Dan Bon One</li>
          <li>Dan Bon Ee Dan / Dan Bon Two</li>
          <li>Gi Cho Hyung Il Bu / Basic Form One</li>
          <li>Gi Cho Hyung Ee Bu / Basic Form Two</li>
          <li>Sae Kye Hyung Il Bu / Sae Kye Hyung One</li>
          <li>Sae Kye Hyung Ee Bu / Sae Kye Hyung Two</li>
        </ul>
      </section>

      <section>
        <h3>Union One Step Sparring</h3>
        <h4>Number 1</h4>
        <p>From sitting position:- The attacker steps forward with right foot, kneeling on the left knee and punch with the right hand   The defender immediately moves left foot forward kneeling on the right knee and simultaneously applies a left inside to outside knife hand block and simultaneously executes a right punch to the face</p>

        <h4>Number 2</h4>
        <p>Attacker punch with left or right hand:- Defender, step back with left foot, inside to outside right knife hand block, immediately grab attacking fist, twist clockwise and execute right side snap kick</p>

        <h4>Number 3</h4>
        <p>Attacker Punch with left or right hand :- Defender, shift right foot 45 degrees N.E. punch with right arm follow by left arm, pull left arm to right waist and execute right punch to face and left knife hand blocking attacker’s right arm</p>

        <h4>Number 4</h4>
        <p>Whilst in normal sitting position:- attacker punch with the right hand, the defender immediately rolls to the left and executes a side snap kick to the face or chest</p>
      </section>

      <section>
        <h3>Tertiary Syllabus</h3>
        <h4>Breakfalls</h4>
        <ul>
          <li>Back breakfall</li>
        </ul>

        <h4>Rolls</h4>
        <ul>
          <li>Forward roll</li>
        </ul>

        <h4>Pad Drills</h4>
        <ol>
          <li>1 jab from fighting guard</li>
          <li>2 jab, cross from fighting guard</li>
          <li>3 knee kick and clinch</li>
        </ol>

        <h4>Break away techniques</h4>
        <ul>
          <li>Single hand break away (Spear)</li>
          <li>Two handed break away</li>
          <li>Dead weight drop (floppy)</li>
          <li>Shoulder slip (arms up break away)</li>
        </ul>
      </section>

      <section>
        <h3>Ho Sin Sul & Grappling Techniques</h3>
        <p><strong>Defensive stance and verbal resolution</strong></p>
        <p>The practitioner must demonstrate a correct defensive stance with verbal resolution. Examples of verbal resolution include: “Get back!”, “Go away!”, “Please calm down”, “I agree”, “I don’t want to fight”.</p>

        <p><strong>Defensive stance footwork and movement toward situation exit</strong></p>
        <p>The practitioner must demonstrate correct footwork moving forward, backward and sideways. The practitioner must then demonstrate keeping safe distance from an aggressor using the demonstrated footwork with further verbal resolution to reach a safe location.</p>
      </section>

      <section>
        <h3>General Knowledge Requirements</h3>
        <p>Candidates must be able to answer the following:</p>
        <ul>
          <li>What is your Union number? (Found in the front of your black membership book)</li>
          <li>How many low blocks in Basic Form 1, 2 and 3?</li>
        </ul>

        <table className="knowledge-table">
          <thead>
            <tr>
              <th>Basic Form One</th>
              <th>Basic Form Two</th>
              <th>Basic Form Three</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>8 low blocks</td>
              <td>8 low blocks</td>
              <td>2 low blocks</td>
            </tr>
            <tr>
              <td>12 middle punches</td>
              <td>6 high blocks</td>
              <td>6 side punches</td>
            </tr>
            <tr>
              <td></td>
              <td>6 high punches </td>
              <td>6 middle blocks</td>
            </tr>
            <tr>
              <td></td>
              <td> </td>
              <td>6 middle punches</td>
            </tr>
          </tbody>
        </table>

        <h4>Short theory & terms</h4>
        <ul>
          <li>What is the meaning of White Belt? — The White Belt is symbolic of purity, novice and hidden potential; it represents the Tang Soo Do student as a seed freshly planted in the ground (WINTER).</li>
          <li>What are low and high block in Korean? — Ha Dan Mahk Kee / Sang Dan Mahk Kee.</li>
          <li>How many movements in Basic Form One, Two and Three? — 20 movements in each form.</li>
          <li>What are middle punch and high punch in Korean? — Chung Dan Kong Kyuk / Sang Dan Kong Kyuk.</li>
          <li>What is the name of the martial art you are studying? — Tang Soo Do.</li>
          <li>What is the name of the style? — Moo Duk Kwan.</li>
          <li>Who is original Grandmaster of Tang Soo Do? — Grandmaster Hwang Kee.</li>
          <li>What do you call front leg raise in Korean? — Ahp Cha Gi.</li>
          <li>Count from one to ten in Korean — Ha-Na, Tul, Set, Net, Da-sot, Yo-sot, Il-Gop, Yo-dol, Ah-hop, Yol.</li>
          <li>What is front stance and ready stance in Korean? — Joon Gul Ja Sa, Joon Bee Ja Sa.</li>
        </ul>
      </section>

      <section>
        <h3>Breaking Techniques (Kyok Pa)</h3>
        <p>Knife hand (Soo Do) chop through a board.</p>
      </section>

      <section>
        <h3>Order of Grading</h3>
        <ol>
          <li>When called up answer: “Yes Sir” or “Nae Kwan Jang Nim”. Line up with the most senior to the right side.</li>
          <li>Bow to top table</li>
          <li>Bow to prefect</li>
          <li>Fitness test</li>
          <li>Demonstration of movement</li>
          <li>Demonstration of techniques</li>
          <li>Hyungs</li>
          <li>Prearranged sparring</li>
          <li>Tertiary syllabus</li>
          <li>Free sparring</li>
          <li>General knowledge</li>
          <li>Breaking</li>
          <li>Bow to the prefect</li>
          <li>Bow to the top table</li>
        </ol>
      </section>
    </div>
  );
}
